import { Component } from "@angular/core";
import { Survey, SurveyGroupValues, SurveyQuestionType } from "./survey";
import { SurveyContainerComponent } from "./survey-container/survey-container.component";

@Component({
    selector: "adapt-root",
    standalone: true,
    imports: [SurveyContainerComponent],
    templateUrl: "./app.component.html",
})
export class AppComponent {
    public archetypeSurvey: Survey;

    public constructor() {

        const currentStateQuestion = "How can things be improved?";
        const futureStateQuestion = "What do you want as an owner?";
        const subQuestion = "Drag to order from most important (top) to less important (bottom)";
        const subQuestion2 = "Drag to order from most impactful (top) to less impactful (bottom)";

        this.archetypeSurvey = new Survey();
        this.archetypeSurvey.questions = [
            // ***************************************** FUTURE STATE **********************
            {
                type: SurveyQuestionType.options,
                question: futureStateQuestion,
                subQuestion: subQuestion,
                options: [
                    {
                        option: "Maximise the valuation of my business",
                        group: SurveyGroupValues.SurveyFutureMaximisation,
                    }, {
                        option: "Have a profitable business for the long term",
                        group: SurveyGroupValues.SurveyFutureIndependence,
                    }, {
                        option: "Keep my business and work less hours than I do now",
                        group: SurveyGroupValues.SurveyFutureFreedom,
                    }, {
                        option: "Be excellent at my craft in the business",
                        group: SurveyGroupValues.SurveyFutureExcellence,
                    }, {
                        option: "Achieve some impact in the world",
                        group: SurveyGroupValues.SurveyFutureVision,
                    },
                ],
            }, {
                type: SurveyQuestionType.options,
                question: futureStateQuestion,
                subQuestion: subQuestion,
                options: [
                    {
                        option: "Improve the saleability of my business",
                        group: SurveyGroupValues.SurveyFutureMaximisation,
                    }, {
                        option: "Realise consistent and healthy dividend returns",
                        group: SurveyGroupValues.SurveyFutureIndependence,
                    }, {
                        option: "Have more discretionary time available",
                        group: SurveyGroupValues.SurveyFutureFreedom,
                    }, {
                        option: "Practice as a principal technician in my business",
                        group: SurveyGroupValues.SurveyFutureExcellence,
                    }, {
                        option: "Change the world for the better",
                        group: SurveyGroupValues.SurveyFutureVision,
                    },
                ],
            }, {
                type: SurveyQuestionType.options,
                question: futureStateQuestion,
                subQuestion: subQuestion,
                options: [
                    {
                        option: "Be positioned well to accept an offer to buy my business",
                        group: SurveyGroupValues.SurveyFutureMaximisation,
                    }, {
                        option: "My business creates financial independence for us",
                        group: SurveyGroupValues.SurveyFutureIndependence,
                    }, {
                        option: "Have better flexibility for time with my family",
                        group: SurveyGroupValues.SurveyFutureFreedom,
                    }, {
                        option: "Deliver to customers and do meaningful work",
                        group: SurveyGroupValues.SurveyFutureExcellence,
                    }, {
                        option: "Realise a greater vision",
                        group: SurveyGroupValues.SurveyFutureVision,
                    },
                ],
            }, {
                type: SurveyQuestionType.options,
                question: futureStateQuestion,
                subQuestion: subQuestion,
                options: [
                    {
                        option: "Demonstrate the commercial success of my business",
                        group: SurveyGroupValues.SurveyFutureMaximisation,
                    }, {
                        option: "Maintain or grow my profit margin over the long term",
                        group: SurveyGroupValues.SurveyFutureIndependence,
                    }, {
                        option: "Pursue other life passions while my business flourishes",
                        group: SurveyGroupValues.SurveyFutureFreedom,
                    }, {
                        option: "Not be bogged down by leadership accountability",
                        group: SurveyGroupValues.SurveyFutureExcellence,
                    }, {
                        option: "Solve a particular problem in the world",
                        group: SurveyGroupValues.SurveyFutureVision,
                    },
                ],
            }, {
                type: SurveyQuestionType.options,
                question: futureStateQuestion,
                subQuestion: subQuestion,
                options: [
                    {
                        option: "Build a business that appeals to interested parties",
                        group: SurveyGroupValues.SurveyFutureMaximisation,
                    }, {
                        option: "All my loved ones are looked after for the future",
                        group: SurveyGroupValues.SurveyFutureIndependence,
                    }, {
                        option: "Freedom to work as much or as little as I choose",
                        group: SurveyGroupValues.SurveyFutureFreedom,
                    }, {
                        option: "Practice mastery in something I love to do",
                        group: SurveyGroupValues.SurveyFutureExcellence,
                    }, {
                        option: "Create a legacy",
                        group: SurveyGroupValues.SurveyFutureVision,
                    },
                ],
            },
            // ***************************************** GAP PAGE **********************
            {
                type: SurveyQuestionType.statement,
                question: "Now, let's figure out your biggest challenge.",
                options: [],
            },
            // ***************************************** CURRENT STATE **********************
            {
                type: SurveyQuestionType.options,
                question: currentStateQuestion,
                subQuestion: subQuestion2,
                options: [
                    {
                        option: "Better alignment between me and my co-owner(s)",
                        group: SurveyGroupValues.CurrentStateNonAlignment,
                    }, {
                        option: "We are trying to scale and it's harder than we thought",
                        group: SurveyGroupValues.CurrentStateGrowingPains,
                    }, {
                        option: "We would benefit from improving our accountability",
                        group: SurveyGroupValues.CurrentStateLackOfClarity,
                    }, {
                        option: "I would like less pressure and operational demand",
                        group: SurveyGroupValues.CurrentStateOverwhelm,
                    }, {
                        option: "A way out of the business that gives me what I want",
                        group: SurveyGroupValues.CurrentStateStuck,
                    },
                ],
            }, {
                type: SurveyQuestionType.options,
                question: currentStateQuestion,
                subQuestion: subQuestion2,
                options: [
                    {
                        option: "More clarity between owners about what the other wants",
                        group: SurveyGroupValues.CurrentStateNonAlignment,
                    }, {
                        option: "We are growing rapidly which brings challenges",
                        group: SurveyGroupValues.CurrentStateGrowingPains,
                    }, {
                        option: "Be clearer on roles, accountabilities and how we deliver",
                        group: SurveyGroupValues.CurrentStateLackOfClarity,
                    }, {
                        option: "Improve the sense of overwhelm I wrestle with",
                        group: SurveyGroupValues.CurrentStateOverwhelm,
                    }, {
                        option: "It feels like I bought a 'job' instead of owning a business",
                        group: SurveyGroupValues.CurrentStateStuck,
                    },
                ],
            }, {
                type: SurveyQuestionType.options,
                question: currentStateQuestion,
                subQuestion: subQuestion2,
                options: [
                    {
                        option: "A fairer contribution of time and energy by all owners",
                        group: SurveyGroupValues.CurrentStateNonAlignment,
                    }, {
                        option: "Guidance with how to grow successfully would help",
                        group: SurveyGroupValues.CurrentStateGrowingPains,
                    }, {
                        option: "Improve our direction and how to get there",
                        group: SurveyGroupValues.CurrentStateLackOfClarity,
                    }, {
                        option: "I want less roles in the business and hand over more",
                        group: SurveyGroupValues.CurrentStateOverwhelm,
                    }, {
                        option: "Improve my feeling of being stuck in this business",
                        group: SurveyGroupValues.CurrentStateStuck,
                    },
                ],
            }, {
                type: SurveyQuestionType.options,
                question: currentStateQuestion,
                subQuestion: subQuestion2,
                options: [
                    {
                        option: "Less passive ownership by others while I do all the work",
                        group: SurveyGroupValues.CurrentStateNonAlignment,
                    }, {
                        option: "We could use infrastructure to help us scale sustainably",
                        group: SurveyGroupValues.CurrentStateGrowingPains,
                    }, {
                        option: "Be more proactive than reactive and work to a plan",
                        group: SurveyGroupValues.CurrentStateLackOfClarity,
                    }, {
                        option: "My time could be spent on higher value tasks",
                        group: SurveyGroupValues.CurrentStateOverwhelm,
                    }, {
                        option: "I'd like succession but I don't know how to do that well",
                        group: SurveyGroupValues.CurrentStateStuck,
                    },
                ],
            }, {
                type: SurveyQuestionType.options,
                question: currentStateQuestion,
                subQuestion: subQuestion2,
                options: [
                    {
                        option: "Achieve what we want which is different for each owner",
                        group: SurveyGroupValues.CurrentStateNonAlignment,
                    }, {
                        option: "The strategy is to expand our market share",
                        group: SurveyGroupValues.CurrentStateGrowingPains,
                    }, {
                        option: "Improve ownership of responsibilities and results",
                        group: SurveyGroupValues.CurrentStateLackOfClarity,
                    }, {
                        option: "Have more time for strategy and driving the direction",
                        group: SurveyGroupValues.CurrentStateOverwhelm,
                    }, {
                        option: "Help with how to transition out of the business well",
                        group: SurveyGroupValues.CurrentStateStuck,
                    },
                ],
            },
        ];

        this.archetypeSurvey.randomiseOptions();
    }
}
